import compact from 'lodash/compact';
import { ReactElement, useMemo } from 'react';

import { protectFeature } from '~libs.shared.system';
import { visitPaths } from '~libs.desktop.shared.paths';

import { dischargeSummaryTranslationKeys } from '../../features/electronicDocuments/translations';
import { referralTranslationKeys } from '../../features/referral/translations';

import { ActionBarDropdownOptionConfigItem, useActionBarDropdownItems } from './VisitActionBar.hooks';

export const useElectronicDocumentsDropdownItems = (visitId: number, reopened: boolean): ReactElement[] => {
   const optionsConfig: ActionBarDropdownOptionConfigItem[] = useMemo(
      () =>
         compact([
            {
               label: referralTranslationKeys.referralType.DIAGNOSTIC_EXAMINATION_ELECTRONIC,
               path: visitPaths.getElectronicReferralToDiagnosticExaminationPath({ params: { visitId: visitId } }),
               id: 'electronicReferralToDiagnosticExamination',
            },
            {
               label: referralTranslationKeys.referralType.SPECIALIST_ELECTRONIC,
               path: visitPaths.getElectronicReferralToSpecialistPath({ params: { visitId: visitId } }),
               id: 'electronicReferralToSpecialist',
            },
            {
               label: referralTranslationKeys.referralType.HOSPITAL_ELECTRONIC,
               path: visitPaths.getElectronicReferralToHospitalPath({ params: { visitId: visitId } }),
               id: 'electronicReferralToHospital',
            },
            protectFeature('issuingDischargeSummary', {
               label: dischargeSummaryTranslationKeys.dischargeSummary,
               path: visitPaths.getDischargeSummaryPath({ params: { visitId: visitId } }),
               id: 'dischargeSummary',
               disabled: reopened,
               tooltipContent: dischargeSummaryTranslationKeys.cannotIssueOnReopenedVisit,
            }),
         ]),
      [reopened, visitId]
   );

   return useActionBarDropdownItems(optionsConfig);
};
